// store/slices/executorSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ExecutorClusterResponse } from '../../common/types/interfaces'

interface ExecutorState {
  clusters: ExecutorClusterResponse[]
  clustersLoaded: boolean
  isExecutor: boolean
  clientUserId: number | null
}

const initialState: ExecutorState = {
  clusters: [],
  clustersLoaded: false,
  isExecutor: false,
  clientUserId: null,
}

export const executorSlice = createSlice({
  name: 'executor',
  initialState,
  reducers: {
    setExecutorClusters: (state, action: PayloadAction<ExecutorClusterResponse[]>) => {
      state.clusters = action.payload
      state.clustersLoaded = true
      state.isExecutor = action.payload.length > 0
    },
    clearExecutorClusters: (state) => {
      state.clusters = []
      state.clustersLoaded = false
      state.isExecutor = false
    },
    setClientUserId: (state, action: PayloadAction<number | null>) => {
      state.clientUserId = action.payload
    },
  },
})

export const { setExecutorClusters, clearExecutorClusters, setClientUserId } = executorSlice.actions

export const selectExecutorClusters = (state: RootState) => state.executor.clusters
export const selectExecutorClustersLoaded = (state: RootState) => state.executor.clustersLoaded
export const selectIsExecutor = (state: RootState) => state.executor.isExecutor
export const selectClientUserId = (state: RootState) => state.executor.clientUserId

export default executorSlice.reducer
